import React, { useEffect, useState } from "react";
import { Box, Input } from "@mui/joy";

const InputPairs = ({ onChange, value, currentLanguageData }) => {
    const [values, setValues] = useState({
        input1: "",
        input2: "",
        input3: "",
        input4: "",
        input5: "",
        input6: "",
    });

    const [isUserEditing, setIsUserEditing] = useState(false);

    useEffect(() => {
        if (value && !isUserEditing) {
            const newValues = {
                input1: Object.keys(value)[0] || "",
                input2: Object.values(value)[0] || "",
                input3: Object.keys(value)[1] || "",
                input4: Object.values(value)[1] || "",
                input5: Object.keys(value)[2] || "",
                input6: Object.values(value)[2] || "",
            };

            if (JSON.stringify(newValues) !== JSON.stringify(values)) {
                setValues(newValues);
            }
        }
    }, [value]); 

    const handleChange = (key, fieldValue) => {
        setIsUserEditing(true);

        const newValues = {
            ...values,
            [key]: fieldValue,
        };

        setValues(newValues);

        const result = {};
        if (newValues.input1 && newValues.input2) result[newValues.input1] = newValues.input2;
        if (newValues.input3 && newValues.input4) result[newValues.input3] = newValues.input4;
        if (newValues.input5 && newValues.input6) result[newValues.input5] = newValues.input6;

        onChange(Object.keys(result).length > 0 ? result : null);

        // Таймер, чтобы дать React обработать onChange и вернуть управление
        setTimeout(() => setIsUserEditing(false), 300);
    };

    return (
        <Box sx={{ display: "flex", flexDirection: "column", gap: 1, width: '100%', margin: "auto" }}>
            {[0, 1, 2].map((rowIndex) => (
                <Box key={rowIndex} sx={{ display: "flex", gap: 1 }}>
                    <Input
                        placeholder={currentLanguageData.buttonText}
                        value={values[`input${rowIndex * 2 + 1}`]}
                        onChange={(e) => handleChange(`input${rowIndex * 2 + 1}`, e.target.value)}
                        sx={{
                            flex: 1,
                            fontSize: 14,
                            borderRadius: 20,
                            '&::before, &::after': { background: 'transparent' },
                            'textarea': { scrollbarWidth: 'none' }
                        }}
                    />
                    <Input
                        placeholder={currentLanguageData.buttonMessage}
                        value={values[`input${rowIndex * 2 + 2}`]}
                        onChange={(e) => handleChange(`input${rowIndex * 2 + 2}`, e.target.value)}
                        sx={{
                            flex: 1,
                            fontSize: 14,
                            borderRadius: 20,
                            '&::before, &::after': { background: 'transparent' },
                            'textarea': { scrollbarWidth: 'none' }
                        }}
                    />
                </Box>
            ))}
        </Box>
    );
};

export default InputPairs;
